import { MessageContainer } from "./VendorLogin.styles";

export default function VendorLogin() {
  return (
    <>
      <MessageContainer/>
    </>
  );
}
